import { RSU } from '_lib/api';
import { Map } from 'leaflet';
import React, { FC, ReactElement } from 'react';

import RsuMarker from './markers/RsuMarker';

const Devices: FC<{ devices: RSU[]; mapRef: Map }> = ({ devices, mapRef }): ReactElement => (
  <>
    {devices.map((device) => (
      <RsuMarker key={device.id} device={device} mapRef={mapRef} />
    ))}
  </>
);

export default React.memo(Devices);
